import { Phone, Clock, MapPin } from "lucide-react";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import SEO from "@/components/SEO";
import ContactForm from "@/components/forms/ContactForm";
import { useSite } from "@/context/SiteContext";
import { track } from "@/lib/api";
import { Link } from "react-router-dom";

export default function Contact() {
  const site = useSite();
  return (
    <>
      <SEO
        title="Contact Michael Janas | 1907 Insurance Group — (877) 833-1907"
        description="Call or message 1907 Insurance Group. Speak directly with independent licensed life insurance agent Michael Janas."
      />
      <PageHero
        eyebrow="Contact"
        title="Let's Talk About What You Want to Protect"
        intro="Call or send a message — whichever is easiest. You'll reach a real person, not a call center."
      />
      <section className="py-14 md:py-20" data-testid="contact-page-content">
        <div className="container-site grid gap-12 lg:grid-cols-[minmax(0,2fr)_minmax(0,3fr)]">
          <Reveal>
            <div className="space-y-4">
              <a href={`tel:${site.phone_href}`} className="flex items-start gap-4 rounded-xl border border-navy-100 bg-white p-6 shadow-sm transition-shadow hover:shadow-md"
                onClick={() => track("phone_click", { location: "contact_page" })} data-testid="contact-phone-card">
                <Phone className="mt-1 h-6 w-6 shrink-0 text-gold-dark" aria-hidden="true" />
                <span>
                  <span className="block font-semibold text-navy text-lg">Call or Text</span>
                  <span className="text-2xl font-serif text-navy">{site.phone_display}</span>
                  <span className="block text-mutedink mt-1">{site.business_hours}</span>
                </span>
              </a>
              <div className="flex items-start gap-4 rounded-xl border border-navy-100 bg-white p-6 shadow-sm" data-testid="contact-area-card">
                <MapPin className="mt-1 h-6 w-6 shrink-0 text-gold-dark" aria-hidden="true" />
                <span>
                  <span className="block font-semibold text-navy text-lg">Service Area</span>
                  <span className="text-mutedink">{site.states_served_text}. Carrier and product availability varies by state.</span>
                </span>
              </div>
              <div className="flex items-start gap-4 rounded-xl border border-navy-100 bg-white p-6 shadow-sm" data-testid="contact-schedule-card">
                <Clock className="mt-1 h-6 w-6 shrink-0 text-gold-dark" aria-hidden="true" />
                <span>
                  <span className="block font-semibold text-navy text-lg">Prefer a Scheduled Call?</span>
                  <Link to="/schedule" className="text-navy underline font-semibold" data-testid="contact-schedule-link"
                    onClick={() => track("schedule_click", { location: "contact_page" })}>
                    Pick a day and time that works for you
                  </Link>
                </span>
              </div>
              <p className="text-sm text-mutedink leading-relaxed">
                Please note: 1907 Insurance Group does not provide emergency services. For claims emergencies, contact
                your insurance carrier directly using the number on your policy documents.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.12}>
            <ContactForm />
          </Reveal>
        </div>
      </section>
    </>
  );
}
